import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { StorageService } from 'src/app/appServices/storage.service';
import { StorageKeys } from 'src/app/appServices/storage-keys';

@Injectable({
  providedIn: 'root'
})
export class TenentContextService {

  constructor(private storageService: StorageService) {}

  async addTenantToHeaders(headers: HttpHeaders): Promise<HttpHeaders> {
    const tenantName = await this.storageService.getItem<string>(StorageKeys.TENANT_NAME);
    if (tenantName) {
      return headers.append("tenant-name", tenantName);
    }
    return headers;
  }
}
